/** Run pre-round parity calcs from a VALUES_CONFIG-style array. */
export function runParityCalcsFromConfig(valuesConfig, wd, variables) {
  const result = {};
  valuesConfig.forEach((v) => {
    result[v.key] = v.calc(wd, variables);
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/shared/parity.js